import { render, staticRenderFns } from "./DialogsTraining.vue?vue&type=template&id=5d7b69b8"
import script from "./DialogsTraining.vue?vue&type=script&lang=js"
export * from "./DialogsTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports